module.exports = __webpack_public_path__ + "img/ordenar.9e5b3e86.svg";